<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
  <div class="container-fluid  mt-5">
    <div class="row" *ngIf="loaded">
      <div class="col-12">
        <p-tabView (onChange)="selectTab($event)">
          <p-tabPanel header="{{'DossierLinks.situation.title' | translate}}">
            <div class="row">
              <div class="col-12 alert alert-info" *ngIf="showInfoAlert()">
                <span> <i class="fas fa-1-5x fa-info-circle m-r-md"
                    aria-hidden="true"></i>{{'DossierLinks.situation.message.info' | translate}}</span>
              </div>
              <div class="col-12 alert alert-warning" *ngIf="showWarningAlert()">
                <span> <i class="fas fa-1-5x fa-info-circle m-r-md"
                    aria-hidden="true"></i>{{'DossierLinks.situation.message.warning' | translate}}</span>
              </div>
              <div class="col-12 alert alert-danger" *ngIf="showDangerAlert()"><span> <i
                    class="fas fa-1-5x fa-info-circle m-r-md"
                    aria-hidden="true"></i>{{'DossierLinks.situation.message.danger' | translate}}</span>
              </div>
              <div class="col-12">
                <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig" [manageWaitService]=false>
                </formPlyca>
              </div>
            </div>
          </p-tabPanel>
          <p-tabPanel header="{{'DossierLinks.phasestatus.title' | translate}}"
            *ngIf="this.usuSoporte && this.model1.procurementProjectStatus!==undefined">
            <div class="row">
              <div class="col-12 alert alert-info" *ngIf="isDivision0()">
                <span> <i class="fas fa-1-5x fa-info-circle m-r-md"
                    aria-hidden="true"></i>{{'DossierLinks.phasestatus.message.info' | translate}}</span>
              </div>
              <div class="col-12 alert alert-warning" *ngIf="!isDivision0()">
                <span> <i class="fas fa-1-5x fa-info-circle m-r-md"
                    aria-hidden="true"></i>{{'DossierLinks.phasestatus.message.info1' | translate}}</span>
              </div>
              <div class="col-12">
                <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
                </formPlyca>
              </div>
              <div class="col-12">
                <formElement [model]="model1" [fieldConfig]="getBuscadorDivisionTree()"
                  (valueChanged)="selectDivision($event)"></formElement>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</p-scrollPanel>